var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgUpArrow = function SvgUpArrow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 4.83642L18.207 11.0434L16.793 12.4574L12 7.66442L7.20697 12.4574L5.79297 11.0434L12 4.83642ZM12 10.4864L18.207 16.6934L16.793 18.1074L12 13.3144L7.20697 18.1074L5.79297 16.6934L12 10.4864Z",
    fill: "currentColor"
  })));
};
export default SvgUpArrow;